import {
  IConnectionPosition,
} from '../core/connection-manager';

export function applyConnectionData(svgPathElement: SVGPathElement, connectionData: IConnectionPosition | undefined) {
  if (!connectionData) {
    // Clear the path if connection data couldn't be calculated
    svgPathElement.setAttribute('d', '');
    return;
  }

  // Update the SVG path with the calculated Bézier curve
  svgPathElement.setAttribute('d', connectionData.svgPath);

  // Update the SVG positioning
  const svg = svgPathElement.closest('svg');
  if (svg) {
    const x = connectionData.svgGeometry.x;
    const y = connectionData.svgGeometry.y;
    const width = connectionData.svgGeometry.width;
    const height = connectionData.svgGeometry.height;

    // We use transform: translate instead of position: absolute + left + right,
    // as transform css is GPU accelerated and provides some significant performance.
    // It also skips the lay-outing phase of the browser and thus gains another
    // performance boost
    svg.style.transform = `translate(${x}px, ${y}px)`;
    // Position SVG element using screen coordinates (for proper panning)
    svg.style.width = `${width}px`;
    svg.style.height = `${height}px`;

    // ViewBox uses world coordinates to match the path data
    svg.setAttribute('viewBox', `0 0 ${width} ${height}`);
  }
}
